import {
  Badge,
  Divider,
  IconButton,
  Tooltip,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./navHeader.module.scss";
import { ReactComponent as HamburgerMenuIcon } from "../../../../svgs/hamburger-menu.svg";
import { ReactComponent as NotificationIcon } from "../../../../svgs/notifications.svg";
import { ReactComponent as Logout } from "../../../../svgs/log-out.svg";
import {  Menu, MenuItem } from "@mui/material";
import { AppDispatch, RootState } from "../../../../providers/store";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  SessionDetails,
  updateSession,
} from "../../../../reduxSlice/sessionSlice";
import { updateTabSession } from "../../../../reduxSlice/tabSlice";
import { ReactComponent as ProfileIcon } from "../../../../svgs/profileIcon.svg";
import { updatePaymentStatus } from "../../../../reduxSlice/paymentStatus";
import { ReactComponent as Tick } from "../../../../svgs/notifitick.svg";
import apiCall from "../../../../utils/apiCall";
import { academicRoute, academicRouteB, corporateRoute, examinationRoute, executiveRoute, militaryRoute, militaryRouteB, practitionerRoute } from "../../../../utils/allRoute";
import { User, updateUserDetails } from "../../../../reduxSlice/useAuthSlice";
import { useNavigate } from "react-router-dom";


interface HeaderProps {
  handleSidebarToggle?: () => void;
}
export interface PaymentStatus {
  ActionName: string;
  Amount: number;
  Status: string;
}

export interface NotificationMessage {
  TotalCount: string;
  Activities: string;
}

export type NotificationType = {
  ActivityDescription: string;
  ActivityId: number;
  ApplicantId: string;
  IsActive: boolean;
};

export interface NotificationModalProps {
  activities?: NotificationMessage[];
  onReadNotification?: (id: number) => void;
}

const NavHeader: React.FC<HeaderProps> = ({ handleSidebarToggle }) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  
  const navigate = useNavigate();

  const sessionDetails = useSelector(
    (state: RootState) => state?.sessionDetails?.sessionDetails
  );
  const user = useSelector(
    (state: RootState) => state?.userDetails?.userDetails
  );
  const dispatch: AppDispatch = useDispatch();
 
  const applicantId = user?.MemberId;

  const nthNumber = (number: number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const getDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const fullDate = [`${day}${nthNumber(day)}`, month, year].join(" ");
    return `${fullDate}`;
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [notificationEl, setNotificationEl] =
    React.useState<null | HTMLElement>(null);
  const openNotification = Boolean(notificationEl);
  const handleClickNotification = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationEl(event?.currentTarget);
  };
  const handleCloseNotification = () => {
    setNotificationEl(null);
  };

  const queryClient = useQueryClient();
  const UpdateNotificationCall = async (id: number) => {
    let url = `/Activity/UpdateNotication?Id=${id}`;
    return (await apiCall().post(url))?.data;
  };

  const updateNotificationMutation = useMutation(
    ["update-Notification"],
    UpdateNotificationCall,
    { retry: 0 }
  );

  const UpdateNotificationHandler = async (id: number) => {
    try {
      await updateNotificationMutation.mutateAsync(id, {
        onSuccess: () => {
          queryClient.refetchQueries(["get-Notifications"]);
          navigate("/notification");
        },
      });
    } catch (error: any) {}
  };

  const getNotifications = async () => {
    let url = `/Activity/GetNotication?applicantId=${applicantId}`;
    return (await apiCall().post(url))?.data;
  };

  const { data } = useQuery(
    ["get-Notifications"],
    getNotifications,
    { retry: 0, refetchOnWindowFocus: false }
  );

  const getNotificationsData = data?.Data;
  


  useEffect(() => {
    setUnreadCount(getNotificationsData?.TotalCount);
     // eslint-disable-next-line
  }, [getNotificationsData]);

  useEffect(() => {
    queryClient.refetchQueries(["get-Notifications"]);
     // eslint-disable-next-line
  }, [updateNotificationMutation?.isSuccess]);

  const filteredNotification = getNotificationsData?.Activities?.filter((item: NotificationType) => (item?.IsActive === true ? true : false));

  let unsortedArray = filteredNotification;
  let sortedArray = unsortedArray?.sort(
    (a: any, b: any) => b.ActivityId - a.ActivityId
  );

  const getActiveSession = () =>
    apiCall().get(`/Applicant/GetApplicantSignup/${user?.MemberId}`);
  
  const sessionQuery = useQuery(["get-active-session"], getActiveSession, {
    retry: 0,
    onSuccess: (data) => {
      dispatch(updateSession(data?.data?.Data as SessionDetails));
    },
  });

  const NotificationMenu = ({ onReadNotification }: NotificationModalProps) => {
    return (
      <React.Fragment>
        <Menu
      
          anchorEl={notificationEl}
          id="account-menu"
          open={openNotification}
          onClose={handleCloseNotification}
          onClick={handleCloseNotification}
  
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          // sx={{width: "50%"}}
        >
          <div>
            {filteredNotification && filteredNotification?.length > 0 && (
              <span className={styles.notificationheader}>NOTIFICATIONS</span>
            )}
            {filteredNotification && filteredNotification?.length === 0 && (
              <MenuItem sx={{ width: "20rem", gap: "1rem" }}>
                <span className={styles.notificationmessage}>
                  No new Notifications
                </span>
              </MenuItem>
            )}

            {getNotificationsData &&
              getNotificationsData?.Activities === null && (
                <MenuItem sx={{ width: "20rem", gap: "1rem" }}>
                  <span className={styles.notificationmessage}>
                    No new Notifications
                  </span>
                </MenuItem>
              )}

            {filteredNotification &&
              filteredNotification?.length > 0 &&
              sortedArray?.map((single: NotificationType) => (
                <div key={single?.ActivityId}>
                  <>
                    <MenuItem
                      sx={{ width: "100%", gap: "1rem" }}
                      onClick={() =>
                        UpdateNotificationHandler(single?.ActivityId)
                      }
                    >
                      <Tick width={20} />
                      <span className={styles.notificationmessage}>
                        {single?.ActivityDescription}
                      </span>

                     
                    </MenuItem>
                    <Divider />
                  </>
                </div>
              ))}
          </div>
        </Menu>
      </React.Fragment>
    );
  };


   const handleLogout = () => {
    handleClose();
    dispatch(updateSession({} as SessionDetails));
    dispatch(updatePaymentStatus({} as PaymentStatus));
    localStorage.removeItem("CIPM-Auth");
    window.localStorage.clear();
    dispatch(updateTabSession("1"));
    dispatch(updateUserDetails({} as User));
    navigate("/login");
  };

  const handleProfile = () => {
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == examinationRoute)
      navigate("/examination-NYSC/profile");
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == practitionerRoute)
      navigate("/practitioner/profile");
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == executiveRoute)
      navigate("/executive/profile");
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == academicRoute) navigate("/academic/profile");
    // eslint-disable-next-line
    if (sessionDetails?.RouteId == academicRouteB) navigate("/profile/academic");
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == militaryRoute) navigate("/military/profile");
    // eslint-disable-next-line
    if (sessionDetails?.RouteId == militaryRouteB) navigate("/profile/military");
     // eslint-disable-next-line
    if (sessionDetails?.RouteId == corporateRoute)
      navigate("/corporate/profile");
    handleClose();
  };


  return (
    <div className={styles.header}>
      <IconButton
        aria-label="open sidebar"
        edge="start"
        onClick={handleSidebarToggle}
        sx={{
          mr: 1,
          visibility: { xs: "visible", md: "hidden" },
          display: { md: "hidden" },
        }}
      >
        <HamburgerMenuIcon className={styles.hamburgerStyle} />
      </IconButton>

      <div className={styles.group}>
        <Tooltip title="Notifications" sx={{ fontSize: "2rem" }}>
          
          <Badge
            badgeContent={unreadCount}
            color="error"
            onClick={handleClickNotification}
            className={styles.button}
          >
            <NotificationIcon style={{ width: "40px", height: "35px" }} />
          </Badge>

        
        </Tooltip>

        <NotificationMenu />

        <Tooltip title="My Account" sx={{ fontSize: "2rem" }}>
          <IconButton
            onClick={handleClick}
            
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            {sessionDetails?.UploadPictureUrl ? (
              <PhotoStyle url={sessionDetails?.UploadPictureUrl} />
            ) : (
              <ProfileIcon style={{ width: "40px", height: "35px" }} />
            )}
          </IconButton>
        </Tooltip>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{ boxShadow: "none", marginTop: "1rem" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem
            onClick={handleProfile}
            style={{
              height: "auto",
              paddingBlock: "1px",
              paddingInline: "5px",
              fontSize: "2rem",
            }}
          >
            <ProfileIcon/>
            View Profile
          </MenuItem>
          <MenuItem
            onClick={handleLogout}
            style={{
              height: "auto",
              paddingBlock: "1px",
              paddingInline: "5px",
              fontSize: "2rem",
            }}
          >
            <Logout />
            Logout
          </MenuItem>
        </Menu>

        <span style={{ fontSize: "1.5rem" }} className={styles.date}>
          {getDate()}
        </span>
      </div>
    </div>
  );
};

export default NavHeader;

interface PhotoStyleProps {
  url?: string;
}

const PhotoStyle = styled("img")<PhotoStyleProps>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100%;
  background-image: url(${(PhotoStyleProps) => PhotoStyleProps?.url});
`;
